var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 42,
    viewBox: "0 0 30 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5113 4.34177C22.6555 1.50823 18.8691 -0.0276299 14.8446 -0.000336687C10.9839 0.031919 7.31915 1.54793 4.52779 4.27229C1.73644 6.99666 0.1311 10.6217 0.0070397 14.48C-0.0425844 16.0059 0.138543 17.517 0.540498 18.9709C0.684408 19.492 0.85313 19.9957 1.04914 20.4845L1.48832 21.4819L11.3858 39.7733C12.1103 41.1107 13.4477 41.9072 14.9687 41.9072C16.4897 41.9072 17.827 41.1082 18.5516 39.7733L28.4491 21.4819L28.8684 20.5316C29.0694 20.0304 29.248 19.5044 29.3969 18.9685C29.7567 17.6708 29.9378 16.3235 29.9378 14.9663C29.9378 10.9467 28.3647 7.17282 25.5113 4.33929V4.34177ZM28.4416 18.7055C28.3027 19.2067 28.1364 19.6979 27.9553 20.1495L27.5658 21.0279L17.6782 39.3019C17.1298 40.3142 16.1175 40.9172 14.9687 40.9172C13.8199 40.9172 12.8051 40.3142 12.2592 39.3019L2.38899 21.0651L1.96471 20.1049C1.79102 19.6657 1.63223 19.1943 1.49824 18.7104C1.12358 17.3532 0.954859 15.9414 0.999521 14.5147C1.23524 7.11824 7.45065 1.05169 14.8521 0.992145C18.6136 0.954926 22.1468 2.40147 24.8116 5.04643C27.4764 7.69139 28.9453 11.2147 28.9453 14.9688C28.9453 16.2367 28.7766 17.4946 28.4416 18.7055Z",
    fill: "#5E718C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9344 7.63715C10.761 7.63715 7.3667 11.0314 7.3667 15.2048C7.3667 19.3782 10.761 22.7725 14.9344 22.7725C19.1078 22.7725 22.502 19.3782 22.502 15.2048C22.502 11.0314 19.1078 7.63715 14.9344 7.63715ZM14.9344 21.78C11.3093 21.78 8.35918 18.8299 8.35918 15.2048C8.35918 11.5798 11.3093 8.62963 14.9344 8.62963C18.5594 8.62963 21.5096 11.5798 21.5096 15.2048C21.5096 18.8299 18.5594 21.78 14.9344 21.78Z",
    fill: "#5E718C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.9407,
    height: 41.91,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.89b95d13c167af2f6ca60a561f93919c.svg";
export { ForwardRef as ReactComponent };